import { setListenersFromSelector } from '../functions/listeners';
import { querySelector } from '../functions/querySelectors';
import scrollTo from '../functions/scrollTo';

const LINK_CLASS = 'js-scroll-to-anchor';
const LINK_INIT_CLASS = 'jcj-init';
const SCROLL_OFFSET = 40;

let formScrollerClick = function(event) {
  event.preventDefault();

  scrollTo(0, querySelector(this.getAttribute('href')).getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET);
};

export default function() {
  setListenersFromSelector(
    `.${LINK_CLASS}`,
    LINK_INIT_CLASS,
    formScrollerClick
  );
}
